import { Grid } from '@material-ui/core';
import classNames from 'classnames';
import React, { FC } from 'react';

import useStyles from './styles';

export interface LayoutProps {
  nodes: Array<React.ReactNode>;
}

export const Layout: FC<LayoutProps> = ({ nodes = [] }) => {
  const styles = useStyles();

  return (
    <Grid
      alignItems="center"
      className={classNames(styles.h100, styles.w100)}
      container
      direction="column"
      justify="center"
      spacing={2}
    >
      {nodes.map((node: React.ReactNode, index: number) => (
        // eslint-disable-next-line react/no-array-index-key
        <Grid key={index} item>
          {node}
        </Grid>
      ))}
    </Grid>
  );
};
